import React from 'react';
import { AlertBox } from './alertBox';

export class ErrorBoundry extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
      message: error.message
    });
  }

  render() {
    if (this.state.hasError) {

      let jsx = (<div>
        <p>Dit is een voor ons onbekende fout:</p>
        <pre>{this.state.message}</pre>
        <p>U kunt proberen de website te herladen. Of kies één van de onderstaande opties.</p>
      </div>);

      return <AlertBox handleAlertClose={
				() => { this.setState({alerts: null}) }
			} title="Er ging iets mis" text={jsx} errorHandle={true}/>;
    }
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/components/errorCatchall.js